import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationLink,
  PaginationPrevious,
  PaginationNext,
  PaginationEllipsis,
} from "@/components/ui/pagination";

type ProductsPaginationProps = {
  currentPage: number;
  lastPage: number;
  perPage?: number;
  maxVisible?: number;
};

export default function PaginationLinks({
  currentPage,
  lastPage,
  perPage = 15,
  maxVisible = 3,
}: ProductsPaginationProps) {
  const pages: (number | "...")[] = [];

  if (lastPage <= 1) {
    return null;
  }

  if (lastPage <= maxVisible) {
    for (let i = 1; i <= lastPage; i++) pages.push(i);
  } else {
    const half = Math.floor(maxVisible / 2);
    let start = Math.max(1, currentPage - half);
    let end = Math.min(lastPage, currentPage + half);

    if (start === 1) {
      end = maxVisible;
    } else if (end === lastPage) {
      start = lastPage - maxVisible + 1;
    } else {
      // برای جلوگیری از دو تا "..."، فقط یکی در وسط اضافه کن
      start = Math.max(2, currentPage - half); // از 2 شروع کن تا فضا برای 1 باشه
      end = Math.min(lastPage - 1, currentPage + half); // تا lastPage-1 تموم کن
    }

    // اضافه کردن صفحه اول
    if (start > 1) {
      pages.push(1);
    }

    // اضافه کردن لینک‌های وسط
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    // اضافه کردن فقط یک "..." در صورت نیاز
    if (start > 1 && end < lastPage) {
      // اگر هر دو سمت نیاز به "..." دارن، فقط یکی در وسط اضافه کن (بعد از end)
      pages.push("...");
    }

    // اضافه کردن صفحه آخر
    if (end < lastPage) {
      pages.push(lastPage);
    }
  }

  return (
    <Pagination>
      <PaginationContent>
        {/* Previous Button */}
        <PaginationItem>
          {currentPage > 1 ? (
            <PaginationPrevious
              href={`?page=${currentPage - 1}&perPage=${perPage}`}
            />
          ) : (
            <span className="pointer-events-none opacity-50">
              <PaginationPrevious href="#" />
            </span>
          )}
        </PaginationItem>

        {/* Page Links */}
        {pages.map((p, i) => (
          <PaginationItem key={i}>
            {p === "..." ? (
              <PaginationEllipsis />
            ) : (
              <PaginationLink
                className="rounded-none"
                href={`?page=${p}&perPage=${perPage}`}
                isActive={p === currentPage}
              >
                {p}
              </PaginationLink>
            )}
          </PaginationItem>
        ))}

        {/* Next Button */}
        <PaginationItem>
          {currentPage < lastPage ? (
            <PaginationNext
              href={`?page=${currentPage + 1}&perPage=${perPage}`}
            />
          ) : (
            <span className="pointer-events-none opacity-50">
              <PaginationNext href="#" />
            </span>
          )}
        </PaginationItem>
      </PaginationContent>
    </Pagination>
  );
}